/***************************************************************************************************
** isValueUndefined
***************************************************************************************************/

export default function isValueUndefined(value) {
  return Boolean(value === undefined || value === null);
}
